import { format } from "date-fns";
import { ptBR } from "date-fns/locale";

export const dateFormatter = (value: string): string => {
    return value
      .replace(/\D/g, '')
      .replace(/(\d{2})(\d)/, '$1/$2')
      .replace(/(\d{2})\/(\d{2})(\d)/, '$1/$2/$3')
      .slice(0, 10);
  };

export const formatDateTimeWithAt = (date: Date) => {
    return format(new Date(date), "dd/MM/yyyy 'às' HH:mm", {
        locale: ptBR,
    });
};
    